import React from 'react'
// import styleCommon from '../Main/common.module.css'

const CustomModal = ({ isVisible, onClose, children, title, modalwidth60 = false, modalwidth=null }) => {
  if (!isVisible) return null
  const handleClose = (e) => {
    if (e.target.id === 'customModalDiv') onClose()
  }
  return (
    <>
      <div className='fixed inset-0 z-50 bg-black bg-opacity-25 backdrop-blur-sm flex justify-center items-center' id='customModalDiv' onClick={handleClose}>
        <div className='flex flex-col' style={{
          width: modalwidth60 ? '60%' : modalwidth!==null ? modalwidth : 'auto'
        }}>
          {
            title ? (<div className='bg-gray-200 p-2 flex items-center justify-between' >
              <h1 className='text-sm font-medium'>{title}</h1>
              <button className='text-black text-sm font-semibold' onClick={() => onClose()}>X</button>
            </div>) : (<div className={`flex items-center justify-end`}>
              <button className='text-black text-sm font-semibold' onClick={() => onClose()}>X</button>
            </div>)}
          {/* <div className='bg-white p-2 rounded '>
            {children}
          </div> */}
          <div className={`${title ? 'bg-white' : 'bg-[#f0f9ff]'} p-2 rounded`} id='custum-modal-id'>
            {children}
          </div>
        </div >
      </div >
    </>
  )
}

export default CustomModal